/**
 * Valid fields for Dental PPO
 */
export const DENTAL_PPO_VALID_FIELDS = new Set([
  "objectType",
  "networkName",

  // Network Fields
  "individualDeductibleType",
  "individualDeductibleAmount",
  "familyDeductibleType",
  "familyDeductibleAmount",
  "annualMaximumType",
  "annualMaximumAmount",
  "preventativeType1Type",
  "preventativeType1Amount",
  "basicType2Type",
  "basicType2Amount",
  "majorType3Type",
  "majorType3Amount",
  "orthoType4Type",
  "orthoType4Amount",
  "orthoMaximumType",
  "orthoMaximumAmount",
  "orthoAgeLimitType",
  "orthoAgeLimitAge",
  "sealants",
  "spaceMaintainers",
  "generalAnesthesia",
  "compositeWhiteFillings",
  "endodontics",
  "periodonticsNonSurgical",
  "periodonticsSurgical",
  "oralSurgerySimple",
  "oralSurgeryComplex",
  "implants",

  // Non-network/general benefit fields
  "deductibleDuration",
  "isDeductibleWaivedPreventative",
  "outOfNetworkReimbursement",
  "maximumRollover",
  "missingToothExclusion",
  "annualOpenEnrollment",
  "dependentAgeLimitYears",
  "employerContribution",
  "serviceWaitingPeriods",

  // Extended (non-v5) fields — CD-1659/CD-1660
  "extended",
]);
